import {MenuItem} from '@/store/types';

export function routes () {
    return [
        {
            name: 'shipping.carrier-list',
            path: '/envios/transportistas',
            component: () => import(/* webpackChunkName: "carrier-list.component" */'@/modules/shipping/components/CarrierList.vue'),
            meta: {
                toolbarTitle: 'Transportistas',
                authRequired: true,
                module: 'shipping.carriers',
                vuex: {
                    loadModules: ['shipping'],
                },
            },
        },
        {
            name: 'shipping.rate-list',
            path: '/envios/tarifas',
            component: () => import(/* webpackChunkName: "rate-list.component" */ '@/modules/shipping/components/RateList.vue'),
            meta: {
                toolbarTitle: 'Tarifas de envío',
                authRequired: true,
                module: 'shipping.rates',
                vuex: {
                    loadModules: ['shipping'],
                },
            },
        },
        {
            name: 'shipping.rate',
            path: '/envios/tarifa/:id',
            component: () => import(/* webpackChunkName: "rate-detail.component" */  '@/modules/shipping/components/RateDetail.vue'),
            meta: {
                toolbarTitle: 'Tarifa de envío',
                authRequired: true,
                module: 'shipping.rate',
                vuex: {
                    loadModules: ['shipping', 'geo'],
                },
            },
        },
    ]
}

export function menu (): MenuItem[] {
    return [
        {
            title: 'Envio y transporte',
            icon: 'mdi-ferry',
            module: 'shipping',
            requireAuthorization: true,
            permission: '@/shipping/admin',
            children: [
                {
                    title: 'Transportistas',
                    icon: 'mdi-truck',
                    routeName: 'shipping.carrier-list',
                    requireAuthorization: true,
                    permission: '@/shipping/admin/carriers',
                },
                {
                    title: 'Tarifas de envío',
                    icon: 'mdi-tag',
                    routeName: 'shipping.rate-list',
                    requireAuthorization: true,
                    permission: '@/shipping/admin/rates',
                },
            ],
        },
    ]
}
